import { Autosuggest } from '@fs/zion-ui'
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import useNotifications from '../../hooks/useNotifications'
import { getTemplesFromDirectory } from '../../services/templeService'

export default function DmcTemplePicker({ label, onSuggestionSelected, onClear, templeCode, fillX, temples }) {
  const { error } = useNotifications()
  const { t } = useTranslation()
  const [templeSuggestions, setTempleSuggestions] = useState()

  const getLabel = () => {
    if (label === null) {
      return undefined
    }
    if (label === undefined) {
      return t('dmcTemplePicker.defaultLabel', 'Temple')
    }
    return label
  }

  const getSelectedItem = () => {
    if (templeCode === '') {
      return { key: 'blank', primaryText: '', templeCode: '' }
    }
    if (templeCode) {
      return templeSuggestions?.find((templeSuggestion) => templeSuggestion.templeCode === templeCode) ?? null
    }
    return null
  }

  useEffect(() => {
    let isCurrent = true

    const convertToSuggestions = (templesData) => {
      if (isCurrent) {
        setTempleSuggestions(
          templesData.map((temple, index) => {
            return {
              key: index,
              primaryText: `${temple.code} - ${temple.name}`,
              templeCode: temple.code,
            }
          })
        )
      }
    }

    // If temples are provided as a prop (as a map), convert them to array
    if (temples) {
      convertToSuggestions(Object.values(temples))
    } else {
      // Otherwise fetch temples
      getTemplesFromDirectory()
        .then(convertToSuggestions)
        .catch((err) => {
          error(`Failed to get temples: ${err?.response?.statusText}`, err)
        })
    }

    return () => {
      isCurrent = false
    }
  }, [error, temples])

  return (
    <>
      {templeSuggestions && (
        <div style={{ maxWidth: fillX ? undefined : '31rem' }}>
          <Autosuggest
            id="dmc-temple-picker"
            label={getLabel()}
            selectedItem={getSelectedItem()}
            suggestions={templeSuggestions}
            onSuggestionSelected={onSuggestionSelected}
            onClear={onClear}
            placeholder={t('templePicker.placeholder', 'Select Temple')}
            highlightMatchingText
            clearable={!!onClear}
          />
        </div>
      )}
    </>
  )
}
